import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, ArrowRight } from 'lucide-react';
export function Slide11Decision() {
  const questions = [{
    q: 'Do we need to create awareness before the congress?',
    ans: 'Pre-Congress Insight Snak'
  }, {
    q: 'Do we need to capture HCP attention near the venue?',
    ans: 'Vicinity Attention Snak'
  }, {
    q: 'Do we need to turn footfall into booth conversations?',
    ans: 'Aisle Ice-Breaker Snak'
  }, {
    q: 'Do we need better preference capture and follow-up?',
    ans: 'Booth Conversation Snak or Post-Congress Follow-Up Snak'
  }];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-20 md:pb-28 relative overflow-hidden" data-id="element-49">
      <header className="mb-10 text-center" data-id="element-50">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-51">
          The decision question is simple:
          <br data-id="element-52" />
          <span className="text-[#E60012]" data-id="element-53">
            where is the biggest bottleneck?
          </span>
        </motion.h2>
      </header>

      <main className="flex-1 max-w-4xl mx-auto w-full flex flex-col justify-center gap-6" data-id="element-54">
        {questions.map((item, index) => <motion.div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex items-center justify-between gap-6 hover:shadow-md transition-shadow group" initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2 + index * 0.1
      }} data-id="element-55">
            <div className="flex items-center gap-4 flex-1" data-id="element-56">
              <div className="p-3 bg-gray-50 rounded-full shrink-0 group-hover:bg-[#E60012]/10 transition-colors" data-id="element-57">
                <HelpCircle className="w-6 h-6 text-gray-400 group-hover:text-[#E60012] transition-colors" data-id="element-58" />
              </div>
              <p className="text-lg font-medium text-[#1A202C]" data-id="element-59">{item.q}</p>
            </div>

            <ArrowRight className="w-5 h-5 text-gray-300 shrink-0" data-id="element-60" />

            <div className="flex-1 text-right" data-id="element-61">
              <span className="inline-block px-4 py-2 bg-[#E60012]/10 text-[#E60012] font-bold rounded-lg text-sm" data-id="element-62">
                Start with: {item.ans}
              </span>
            </div>
          </motion.div>)}
      </main>

      <motion.footer className="mt-10 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 0.8
    }} data-id="element-63">
        <p className="text-xl font-medium text-[#2D3748]" data-id="element-64">
          Pick one bottleneck. Build one focused Snak. Use the data to decide
          what comes next.
        </p>
      </motion.footer>
    </div>;
}